//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sync } from 'vuex-pathify'
import { Language, ContentType } from '@constants'
import { slugify } from '../../utils'

const colours = Object.freeze(['danger', 'info', 'warning', ''])

export default {
  name: 'Menu',
  props: {
    navbarItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ContentType,
      open: false,
      contentCollections: []
    }
  },
  computed: {
    filters: sync('filters'),
    navbar: sync('navbar'),
    language() {
      return this.$store.get('language/locale') || 'en'
    },
    languageId() {
      return this.language === 'en' ? Language.ENGLISH : Language.DUTCH
    },
    languages() {
      return this.$store.get('language/locales')
    },
    navbarItemsInCurrentLanguage() {
      return this.navbarItems.filter((x) => x.languageId === this.languageId)
    },
    colours() {
      return colours
    }
  },
  methods: {
    toggle() {
      this.open = !this.open
    },
    onNavigate(navbarItem) {
      if (!this.getPath(navbarItem)) {
        return
      }

      this.setFilterOptions({
        contentCollectionId: navbarItem.contentCollectionId,
        contentTypeId: navbarItem.contentTypeId,
        regionId: navbarItem.regionId,
        countryId: navbarItem.countryId
      })

      if (navbarItem.contentCollection || navbarItem.contentType || navbarItem.region || navbarItem.country) {
        this.$store.set('navbar/selectedHeader', navbarItem.name)
      }

      if (!navbarItem.path || navbarItem.path.indexOf('/') === 0) {
        this.$router.push({ path: this.getPath(navbarItem) })
      } else window.location.href = this.getPath(navbarItem)

      this.open = false
    },
    getPath(navbarItem) {
      if (navbarItem.contentCollection) {
        return `/${navbarItem.contentCollection.slug}`
      } else if (navbarItem.contentType) {
        return `/${slugify(navbarItem.contentType.name)}`
      } else if (navbarItem.region) {
        return `/${slugify(navbarItem.region.name)}`
      } else if (navbarItem.country) {
        return `/${slugify(navbarItem.country.name)}`
      }

      return navbarItem.path
    },
    onLanguageSelect(language) {
      this.$root.$i18n.setLocale(language.code)
      this.$dayjs.locale(language.code)
      this.$store.set('language/locale', language.code)

      this.$nuxt.$emit('language-change', language)
    }
  }
}
